module.exports = __webpack_public_path__ + "mongodb-icon.svg?6b7c2d2f6d1c99cbd2bdadcb832d476f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/skill-icons/mongodb-icon.svg
// module id = 53
// module chunks = 0